import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";

import QuillEditor from "./QuillEditor";
import Quill from "quill";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    },
}));

/**
 * @param {Function} onChange
 * @param {string} value
 * @returns {JSX.Element}
 * @constructor
 */
const TextContentRowFormatted = ({onChange, value}) => {
    const classes = useStyles();
    const [t, i18n] = useTranslation();

    const Delta = Quill.import('delta');
    const quillRef = useRef();

    const [initialValue, setInitialValue] = useState(() => {
        if (value) {
            try {
                if (typeof value === 'string' && ((value.startsWith('{') && value.endsWith('}')) || (value.startsWith('[') && value.endsWith(']')))) {
                    return new Delta(JSON.parse(value));
                } else {
                    return new Delta().insert(value);
                }
            } catch (e) {
                console.error("Failed to parse initial value:", e);
                return new Delta().insert(value);
            }
        }

        return new Delta().insert(value);
    });

    return(
        <div className={classes.wrapper}>
            <QuillEditor
                ref={quillRef}
                readOnly={false}
                onTextChange={(delta, oldDelta, source) => {onChange(delta, oldDelta, source, quillRef.current)}}
                defaultValue={initialValue}
                placeholder={ t('article.edit.enterAText') }
            />
        </div>
    )
}

export default TextContentRowFormatted;
